export class NumberConstants {
    static readonly EnumerationGroupQuantityId = 1000;
}